import { PathInput } from "@/modules/admin-panel/bpm-routes/shared/ui/path-input";
import Form, { FormProps } from "@/shared/form/form";
import { FieldsType } from "../model/types";

export function DynamicProcessPathForm(props: FormProps<FieldsType>) {
  return (
    <Form {...props}>
      <PathInput name="route" />
    </Form>
  );
}
